import { Chip } from "@mui/material"

interface RetractionReasonListProps {
    reasons: string[]
}

function RetractionReasonList({ reasons }: RetractionReasonListProps) {
    return <>{
        reasons.map((reason, reasonIndex) =>
                <Chip key={reasonIndex}
            label={reason.replace(/^(\+)/, "")} sx={{ m: 1}}
             variant={reasonIndex % 2 === 0 ? "outlined" : "filled"} />
            )
    }</>
}

export default RetractionReasonList